<template>
  <div>
    <CrudList
      title="Tamaños de Spots"
      storeName="Size_spots"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      sortable
      next-link="/admin/amenities"
      :breadcrumbs="[
        {
          text: 'Spots y vehículos',
          disabled: false,
          href: '/admin/size_spots'
        },
        {
          text: 'Tamaños de Spots',
          disabled: false,
          href: '#'
        },
      ]"
    >
      <template v-slot:icon="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-list-item-avatar v-if="item.icon">
              <img :src="item.icon" alt="" />
            </v-list-item-avatar>
          </v-col>
        </v-row>
      </template>

    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
